import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="user-video-event"
// Saves how far the user has watched, and records when a video is finished.
export default class extends Controller {
  static values = {
    videoTime: { type: String, default: "0" },
    completeUrl: { type: String, default: "" },
    updateUrl: { type: String, default: "" },
  }

  connect() {
    this.iframe = this.element.querySelector('iframe');
    this.player = new Vimeo.Player(this.iframe);
    // Kept up to date as the video plays, because the position cannot be
    // asked for while the page is closing.
    this.currentTime = parseFloat(this.videoTimeValue) || 0;

    this.player.on('timeupdate', (data) => {
      this.currentTime = data.seconds;
      this.hasPlayed = true;
    });

    this.player.on('ended', () => {
      this.post(this.completeUrlValue, {});
      this.showVideoLightBox();
    });

    this.player.on('pause', () => {
      this.sendWatchTime();
    });

    this.boundSendWatchTime = this.sendWatchTime.bind(this);

    window.addEventListener('pagehide', this.boundSendWatchTime);
    document.addEventListener('turbo:before-visit', this.boundSendWatchTime);
  }

  disconnect() {
    window.removeEventListener('pagehide', this.boundSendWatchTime);
    document.removeEventListener('turbo:before-visit', this.boundSendWatchTime);
  }

  // The completion lightbox only exists on course pages.
  showVideoLightBox() {
    const videoCompletionLightbox = document.getElementById('video-completion-lightbox');
    if (!videoCompletionLightbox) return;

    videoCompletionLightbox.classList.remove('hidden');
    // Trigger reflow to ensure transition works
    void videoCompletionLightbox.offsetWidth;
    // Fade in
    videoCompletionLightbox.classList.add('opacity-100');
  }

  closeVideoLightBox() {
    const videoCompletionLightbox = document.getElementById('video-completion-lightbox');
    if (!videoCompletionLightbox) return;

    // Fade out
    videoCompletionLightbox.classList.remove('opacity-100');

    // Wait for transition to complete before hiding
    setTimeout(() => {
      videoCompletionLightbox.classList.add('hidden');
    }, 300); // 300ms matches the duration-300 class
  }

  sendWatchTime() {
    // Nothing to save if the video was opened but never played.
    if (!this.hasPlayed) return;

    this.post(this.updateUrlValue, { video_time: this.currentTime });
  }

  // keepalive lets the request finish even when it is sent as the page closes.
  post(url, body) {
    const csrfToken = document.querySelector('meta[name="csrf-token"]');

    fetch(url, {
      method: "POST",
      keepalive: true,
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken ? csrfToken.getAttribute('content') : ""
      },
      body: JSON.stringify(body)
    }).catch(error => console.warn("Saving video progress failed", error));
  }
}
